import React from "react";
import { useCallback } from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import { useEffect, useState, useRef } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import "./Spinner.css";
import * as XLSX from "xlsx";
import _ from "lodash";
import EditIcon from "@mui/icons-material/Edit";
import toast, { Toaster } from "react-hot-toast";
import DeleteConfirmation from "./components/DeleteConfirmation";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Modal } from "react-bootstrap";
import { BlobServiceClient } from "@azure/storage-blob";
import Swal from "sweetalert2";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import AADHeader from "./components/AADHeader.js";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./table.css";
import { IoEye } from "react-icons/io5";
import Tooltip from "@mui/material/Tooltip";
import { Link2 } from "lucide-react";
import { IoIosCloseCircleOutline } from "react-icons/io"; // Fixes Line 1407
import Dropzone from "react-dropzone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { normalizePayloadRow } from "./utils/connectorConfigUtils";
import { isDateColumnHeader, excelSerialToIsoDateString, normalizeTextDate, normalizeUploadDatesInRows, validateUploadDateRows, validateUploadDataFrequency, buildDateValidationSummary } from "./utils/uploadDateUtils";
import { getCountryForSiteLocation } from "./utils/countryDateFormat";
import { analyzePlatformPeriodConflicts, confirmPlatformPeriodOverwrite, extractPlatformPeriodsFromHistory, extractUploadPeriods, fetchMetricReportHistory, getMetricDateValidationPolicy } from "./utils/periodOverlapUploadUtils";

// const useStyles = makeStyles(theme => (containerTheme(theme)));

const modal = {
  widthCustom: {
    width: 800,
  },
};

export default function Home() {
  const username = localStorage.getItem("userName");
  const navigate = useNavigate();

  const RedirectToEditConfiguration = (esgMetric, siteLocationId) => {
    console.log("RedirectToEditConfiguration Props");
    console.log(esgMetric, siteLocationId);
    // Yönlendirme
    navigate("/neweditconfig", {
      state: { esgMetric, siteLocationId },
    });
  };

  var myHeaders = new Headers();
  myHeaders.append("username", username);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  // const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleOpen = () => {
    setIsModalOpen(true);
    console.log(isModalOpen);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [sloading, setSloading] = React.useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Icon1 = "./assets/img/Assets/configration_icon/White/1.png";
  const Icon2 = "./assets/img/Assets/configration_icon/White/2.png";
  const Icon3 = "./assets/img/Assets/configration_icon/White/3.png";
  const Icon4 = "./assets/img/Assets/configration_icon/White/4.png";
  const Icon5 = "./assets/img/Assets/configration_icon/White/5.png";
  const customIcons = [Icon1, Icon2, Icon3, Icon4, Icon5];

  const iconDotInactive = "./assets/img/Assets/configration_icon/Teal Green/Ellipse 61.png";
  const iconBackgroundInactive = "./assets/img/Assets/configration_icon/Teal Green/Ellipse 59.png";

  const steps = [
    {
      label: "Select data type",
      description: ``,
      active: 1,
    },
    {
      label: "Choose data connector",
      description: "",
      active: 2,
    },
    {
      label: "Create connection",
      description: "",
      active: 3,
    },
    {
      label: "Map fields",
      description: "",
      active: 4,
    },
    {
      label: "Review and finish",
      description: "",
      active: 5,
    },
  ];

  const [count, setCount] = useState(1);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setMatrics(matrics);
    setMyModule(mymodule);
    setCount((prevCount) => prevCount + 1);
    console.log(activeStep);
    console.log(count);
    if (activeStep === 1) {
      fetchFields();
    }
    if (activeStep === 3) {
      var inps = document.getElementsByName("destination[]");
      let destination = [];
      for (var i = 0; i < inps.length; i++) {
        var inp = inps[i];
        destination.push(inp.value);
      }
      console.log(destination);
      setRightHeader(destination);

      var inps1 = document.getElementsByName("excelHeaders[]");
      console.log(inps1);
      let excelHeaders1 = [];
      for (var i = 0; i < inps1.length; i++) {
        var inp1 = inps1[i];
        excelHeaders1.push(inp1.value);
      }

      setLeftHeader(excelHeaders1);
      console.log(excelHeaders1);
    }
  };

  const handleBackConfig = () => {
    setShowTable(false);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setCount((prevCount) => prevCount - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  async function fetchFields() {
    try {
      var myH = new Headers();
      myH.append("username", username);
      myH.append("modulename", mymodule);
      myH.append("pattern", selectedExcel);
      myH.append("ESGMetric", matrics);
      var requestO = {
        method: "GET",
        headers: myH,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}get-fields`, requestO);
      const data = await response.json();
      setFields(data.data);
    } catch (error) {
      console.error(error);
    }
  }

  let handleSubmit = async (e) => {
    e.preventDefault();
    console.log(leftheader);
    console.log(rightheader);
    var newArray = leftheader.map((e, i) => e + ":" + rightheader[i]);
    console.log(newArray);
    const inputArray = newArray;

    const outputObject = inputArray.reduce((result, item) => {
      const [key, value] = item.split(":");
      result[key] = value;
      return result;
    }, {});

    console.log(outputObject);

    var str = JSON.stringify(newArray);
    var final1 = str
      .replace(/{|},|}/g, "")
      .replace(/\[|]|"/g, "")
      .replace(/,/g, ",");
    console.log(final1);
    var result = newArray.reduce(function (map, obj) {
      console.log(obj);
      map[obj] = obj;
      return map;
    }, {});
    console.log(result);
    console.log(Object.entries(newArray).map(([key, value]) => `My key is ${key} and my value is ${JSON.stringify(value)}`));
    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}UpdateConnectorConfig`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({
          siteLocationId: site,
          fileFormat: selectedExcel,
          module: mymodule,
          esgmetric: matrics,
          fieldMapping: outputObject,
        }),
      });
      if (res.status === 200) {
        setEditIsOpen(false);
        const responseJson = await res.json();
        if (responseJson.success == false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.data,
          });
        } else if (responseJson.status == 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.title,
          });
        } else {
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connector Config Updated successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
        }
      } else {
        setEditIsOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error In Update Connector Config",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const excelH = async (e, i) => {
    document.getElementById("excel" + i).value = e;
  };

  const saveData = async () => {
    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}update-businessunit`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
        },
        body: JSON.stringify({}),
      });
      //let resJson = await res.json();
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.data,
          });
        } else if (responseJson.status == 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.title,
          });
        } else {
          fetchConnectorConfig();
          Swal.fire({
            icon: "success",
            title: "Business Unit Updated successfully",
          });
        }
        setEditIsOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error In Update Business Unit",
        });
        setEditIsOpen(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [config, setConfig] = useState("");
  const [activeconfig, setActiveConfig] = useState("");
  const [deactiveconfig, setDeactiveConfig] = useState("");
  const [importfile, setImportFile] = React.useState("");
  const [headerfields, setHeaderFields] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const [editIsOpen, setEditIsOpen] = React.useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
  const [site, setSite] = React.useState("");
  const [file, setFile] = React.useState("");
  const [esg, setESG] = React.useState("");
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [deletename, setDeleteName] = useState(null);
  const [modules, setModules] = React.useState(false);
  const [mymodule, setMyModule] = useState("");
  const [module, setModule] = useState("");
  const [excelfields, setFields] = React.useState(false);
  const [pattern, setPattern] = useState("");
  const [sitelocation, setSiteLocation] = useState("");
  const [sitelocation1, setSiteLocation1] = useState("");
  const [leftheader, setLeftHeader] = useState("");
  const [rightheader, setRightHeader] = useState("");
  const [matrics, setMatrics] = useState("");
  const [mymatrics, setMyMatrics] = useState("");
  const [activeStep, setActiveStep] = React.useState(0);
  // const [selectedExcel, setSelectedExcel] = useState("");
  const [showTable, setShowTable] = React.useState(false);
  const [searchsite, setSearchSite] = useState("");
  const [searchesg, setSearchESG] = useState("");
  const [activeCounter, setActiveCounter] = useState();
  const [inactiveCounter, setInActiveCounter] = useState();
  const [filterValue, setFilterValue] = useState("siteLocationId");
  const [showDefaultModal, setShowDefaultModal] = useState(false);
  const [selectedExcel, setSelectedExcel] = useState([]);
  const [connectorNames, setConnectorNames] = useState({});
  const [currentRowData, setCurrentRowData] = useState(null);
  const excelFileRef = useRef(null);
  const pdfFileRef = useRef(null);
  const selectedConnectorTypeRef = useRef("Excel");

  const handleConnectorModal = (connectorList, connectorNameMap, rowData) => {
    console.log("=== Connector Modal Debug ===");
    console.log("Connector List:", connectorList);
    console.log("Connector Names:", connectorNameMap);
    console.log("Row Data Full:", rowData);
    console.log("Number of connectors:", connectorList.length);
    console.log("=============================");

    setSelectedExcel(connectorList); // Example: ["Excel", "API"]
    setConnectorNames(connectorNameMap); // Example: { Excel: "Abc.xls", API: "Connect1.api" }
    // Store the row data for reference in handleUpload
    setCurrentRowData(rowData);
    setShowDefaultModal(true);
  };

  const handleCloseDefaultModal = () => {
    setShowDefaultModal(false); // Assumes `setShowDefaultModal` is in state
  };

  const handleExcelFileChange = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    setSloading(true);
    const file = files[0];
    const currentRow = currentRowData;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const data = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: true });

      const isDateKey = isDateColumnHeader;
      const newdatas = [];
      data.map((row, index) => {
        const convertedRow = {};
        for (let key in row) {
          if (typeof row[key] === "number") {
            if (isDateKey(key) && row[key] >= 1) {
              convertedRow[key] = excelSerialToIsoDateString(row[key]);
            } else {
              convertedRow[key] = row[key].toString();
            }
          } else if (row[key] instanceof Date) {
            if (isDateKey(key)) {
              const d = row[key];
              convertedRow[key] = d.getUTCFullYear() + "-" + String(d.getUTCMonth() + 1).padStart(2, "0") + "-" + String(d.getUTCDate()).padStart(2, "0");
            } else {
              convertedRow[key] = row[key];
            }
          } else if (typeof row[key] === "string" && isDateKey(key)) {
            // Normalize slash/dot/named-month text; leave raw if unparseable so validation can flag it.
            convertedRow[key] = normalizeTextDate(row[key]) || row[key];
          } else {
            convertedRow[key] = row[key];
          }
        }
        convertedRow.__rowNumber = index + 2;
        const normalizedRow = normalizePayloadRow(convertedRow);
        // keep row number after key strip (normalizePayloadRow copies all keys)
        normalizedRow.__rowNumber = index + 2;
        newdatas.push(normalizedRow);
        return normalizedRow;
      });

      if (!newdatas || newdatas.length === 0) {
        setSloading(false);
        Swal.fire({ icon: "error", title: "Error", text: "No data found in Excel file or data structure is incorrect" }).then(() => handleCloseDefaultModal());
        return;
      }

      if (!currentRow) {
        setSloading(false);
        Swal.fire({ icon: "error", title: "Error", text: "Could not find configuration details for this connector" }).then(() => handleCloseDefaultModal());
        return;
      }

      const siteCountry = getCountryForSiteLocation(sitelocation, currentRow.siteLocationId);
      const dateNormalizationErrors = normalizeUploadDatesInRows(newdatas, { country: siteCountry });
      if (dateNormalizationErrors.length > 0) {
        setSloading(false);
        const errorHtml = dateNormalizationErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 4px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Validation Error</h4>
            <p style="font-size:16px; margin-bottom: 12px;">${buildDateValidationSummary(dateNormalizationErrors)}</p>
            <div style="max-height: 300px; overflow-y: auto; text-align: left;">${errorHtml}</div>`,
        }).then(() => handleCloseDefaultModal());
        return;
      }

      const metricForPolicy = currentRow.topic || currentRow.esgMetric;
      const datePolicy = getMetricDateValidationPolicy(metricForPolicy);
      const uploadedRowsForValidation = newdatas.map((row) => ({
        rowNumber: row.__rowNumber,
        data: row,
      }));

      let overlapErrors = [];
      if (datePolicy.mode !== "none") {
        if (datePolicy.frequencyCheck) {
          const { errors: frequencyErrors } = validateUploadDataFrequency(uploadedRowsForValidation, currentRow.reportFrequency);
          if (frequencyErrors.length > 0) {
            setSloading(false);
            const errorHtml = frequencyErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 4px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
            Swal.fire({
              icon: "error",
              html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Validation Error</h4>
                <p style="font-size:16px; margin-bottom: 12px;">${buildDateValidationSummary(frequencyErrors)}</p>
                <div style="max-height: 300px; overflow-y: auto; text-align: left;">${errorHtml}</div>`,
            }).then(() => handleCloseDefaultModal());
            return;
          }
        }
        const checkPeriodOverlap = datePolicy.mode === "period" || datePolicy.mode === "typedPeriod";
        ({ errors: overlapErrors } = validateUploadDateRows(uploadedRowsForValidation, {
          checkPeriodOverlap,
          getTypeKey: datePolicy.mode === "typedPeriod" ? datePolicy.getTypeKey : null,
          typeLabel: datePolicy.typeLabel || null,
        }));
      }

      const stripRowNumbers = () =>
        newdatas.map((row) => {
          const { __rowNumber, ...rest } = row;
          return rest;
        });

      const confirmPlatformOverwriteIfNeeded = async () => {
        if (!datePolicy.platformOverwrite) return false;
        try {
          const { raw } = await fetchMetricReportHistory(username, currentRow.siteLocationId, metricForPolicy);
          const platformPeriods = extractPlatformPeriodsFromHistory(raw, datePolicy);
          const uploadPeriods = extractUploadPeriods(uploadedRowsForValidation, datePolicy);
          const platformConflicts = analyzePlatformPeriodConflicts(uploadPeriods, platformPeriods, datePolicy);
          if (!platformConflicts.hasConflicts) return false;
          setSloading(false);
          const confirmed = await confirmPlatformPeriodOverwrite({ ...platformConflicts, policy: datePolicy });
          if (!confirmed) return null;
          setSloading(true);
          return true;
        } catch (err) {
          console.error("Platform period check failed:", err);
          return false;
        }
      };

      const runReport = (payload, replaceOverlapping = false) => {
        const fileFormat = selectedConnectorTypeRef.current || currentRow.fileFormat || "Excel";
        fetch(`${process.env.REACT_APP_BASE_API_URL}RunReportNewConfig`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
            site: currentRow.siteLocationId,
            type: fileFormat,
            esgmetric: currentRow.topic || currentRow.esgMetric,
            topic: currentRow.topic || "",
            subtopic: currentRow.subtopic || "",
            ...(replaceOverlapping ? { replaceoverlappingperiods: "true" } : {}),
          },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((data) => {
            setSloading(false);
            if (data.success == false) {
              Swal.fire({ icon: "error", title: "Oops...", text: data.data }).then(() => handleCloseDefaultModal());
            } else if (!data.data || typeof data.data !== "object") {
              Swal.fire({ icon: "error", title: "Oops...", text: typeof data.data === "string" ? data.data : "Unexpected response from server" }).then(() => handleCloseDefaultModal());
            } else {
              if (data.data.totalRecords === data.data.successfulRecords) {
                Swal.fire({
                  icon: "success",
                  title: "Report Run Successfully",
                  html: '<div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' + data.data.totalRecords + '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left45">Success Records: </div><div class="col-md-3 wd-20">' + data.data.successfulRecords + "</div></div>",
                }).then(() => handleCloseDefaultModal());
              }
              if (data.data.totalRecords == data.data.failedRecords) {
                const errMap1 = {};
                if (data.data.failedResults && Array.isArray(data.data.failedResults)) {
                  data.data.failedResults.forEach((failedRecord, index) => {
                    if (failedRecord.errors && Array.isArray(failedRecord.errors)) {
                      const rowNum = failedRecord.rowNumber ?? index + 1;
                      failedRecord.errors.forEach((error) => {
                        if (!errMap1[error]) errMap1[error] = [];
                        errMap1[error].push(rowNum);
                      });
                    }
                  });
                }
                const uniqErrs1 = Object.keys(errMap1);
                const allSame1 = uniqErrs1.length === 1 && errMap1[uniqErrs1[0]].length === data.data.failedRecords;
                let allErrHtml1 = "";
                if (uniqErrs1.length > 0) {
                  allErrHtml1 = allSame1
                    ? `<div style="max-height:200px;overflow-y:auto;text-align:left;margin-top:12px;border-top:1px solid #e0e0e0;padding-top:10px;"><p style="font-size:13px;color:#CC2229;margin:4px 0;">• ${uniqErrs1[0]} (all ${data.data.failedRecords} rows)</p><p style="font-size:13px;color:#888;margin-top:8px;font-style:italic;">Tip: The same error on every row usually means the uploaded file uses the wrong template or has incorrect column names.</p></div>`
                    : `<div style="max-height:200px;overflow-y:auto;text-align:left;margin-top:12px;border-top:1px solid #e0e0e0;padding-top:10px;"><p style="font-size:14px;font-weight:bold;margin-bottom:6px;">Error details:</p>${uniqErrs1
                        .map((e) => {
                          const r = errMap1[e];
                          const lbl = r.length > 3 ? `rows ${r.slice(0, 3).join(", ")} and ${r.length - 3} more` : `row${r.length > 1 ? "s" : ""} ${r.join(", ")}`;
                          return `<p style="font-size:13px;margin:3px 0;color:#CC2229;">• ${e} (${lbl})</p>`;
                        })
                        .join("")}</div>`;
                }
                Swal.fire({ icon: "error", title: "Report Import Failed", html: '<div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' + data.data.totalRecords + '</div></div><div class="col-md-12 flex1"> <div class="col-md-9 wd-70 pd-left35">Invalid Records: </div><div class="col-md-3 wd-20">' + data.data.failedRecords + "</div></div>" + allErrHtml1, width: "600px" }).then(() => handleCloseDefaultModal());
              }
              if (data.data.failedRecords >= 1 && data.data.totalRecords !== data.data.failedRecords) {
                const partErrMap1 = {};
                if (data.data.failedResults && Array.isArray(data.data.failedResults)) {
                  data.data.failedResults.forEach((failedRecord, index) => {
                    if (failedRecord.errors && Array.isArray(failedRecord.errors)) {
                      const rowNum = failedRecord.rowNumber ?? index + 1;
                      failedRecord.errors.forEach((error) => {
                        if (!partErrMap1[error]) partErrMap1[error] = [];
                        partErrMap1[error].push(rowNum);
                      });
                    }
                  });
                }
                const partUniq1 = Object.keys(partErrMap1);
                let partErrHtml1 = "";
                if (partUniq1.length > 0) {
                  partErrHtml1 = `<div style="max-height:200px;overflow-y:auto;text-align:left;margin-top:12px;border-top:1px solid #e0e0e0;padding-top:10px;"><p style="font-size:14px;font-weight:bold;margin-bottom:6px;">Error details for failed rows:</p>${partUniq1
                    .map((e) => {
                      const r = partErrMap1[e];
                      const lbl = r.length > 3 ? `rows ${r.slice(0, 3).join(", ")} and ${r.length - 3} more` : `row${r.length > 1 ? "s" : ""} ${r.join(", ")}`;
                      return `<p style="font-size:13px;margin:3px 0;color:#CC2229;">• ${e} (${lbl})</p>`;
                    })
                    .join("")}</div>`;
                }
                Swal.fire({
                  icon: "warning",
                  title: "Report Run Successfully",
                  html:
                    '<div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' +
                    data.data.totalRecords +
                    '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left45">Success Records: </div><div class="col-md-3 wd-20">' +
                    data.data.successfulRecords +
                    '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left35">Invalid Records: </div><div class="col-md-3 wd-20">' +
                    data.data.failedRecords +
                    "</div></div>" +
                    partErrHtml1,
                  width: "600px",
                }).then(() => handleCloseDefaultModal());
              }
            }
          })
          .catch((error) => {
            setSloading(false);
            Swal.fire({ icon: "error", title: "Oops...", text: "Error In Run Report" }).then(() => handleCloseDefaultModal());
          });
      };

      if (overlapErrors.length > 0) {
        setSloading(false);
        const errorHtml = overlapErrors.map(({ row, error }) => `<p style="font-size:13px; margin: 4px 0; color: #CC2229;">Row ${row}: ${error}</p>`).join("");
        const summaryText = buildDateValidationSummary(overlapErrors);
        Swal.fire({
          icon: "error",
          html: `<h4 style="color: #CC2229; font-size: 20px; font-weight: bold;">Validation Error</h4>
            <p style="font-size:16px; margin-bottom: 12px;">${summaryText}</p>
            <div style="max-height: 300px; overflow-y: auto; text-align: left;">${errorHtml}</div>`,
          iconHtml: '<img src="assets/img/error.png" style="width: 55px; height: 55px;" />',
          width: "650px",
        }).then(() => handleCloseDefaultModal());
        return;
      }

      (async () => {
        const replace = await confirmPlatformOverwriteIfNeeded();
        if (replace === null) {
          setSloading(false);
          handleCloseDefaultModal();
          return;
        }
        runReport(stripRowNumbers(), replace);
      })();
    };
    reader.readAsBinaryString(file);
  };

  const handleUpload = (row) => {
    selectedConnectorTypeRef.current = row.type || "Excel";
    if (excelFileRef.current) {
      excelFileRef.current.value = "";
      excelFileRef.current.click();
    }
  };

  const handleRun = (row) => {
    // Get the current row data from the modal context
    const currentRow = currentRowData;

    if (currentRow) {
      runReport(currentRow.esgMetric, currentRow.siteLocationId, currentRow.fileFormat);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not find configuration details for this connector",
      });
    }
  };

  const handlePdfFileChange = async (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const currentRow = currentRowData;
    if (!currentRow) {
      Swal.fire({ icon: "error", title: "Error", text: "Could not find configuration details for this connector" });
      return;
    }

    const file = files[0];
    setSloading(true);
    try {
      const sasRes = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, { method: "GET" });
      if (sasRes.status !== 200) throw new Error("Failed to get SAS token");

      const sasJson = await sasRes.json();
      const blobServiceClient = new BlobServiceClient(sasJson.data);
      const containerClient = blobServiceClient.getContainerClient("ecoprismfilecontainer");
      const companyId = localStorage.getItem("company_id") || "default";
      const blobPath = `${companyId}/Configuration/PDF/${file.name}`;
      const blockBlobClient = containerClient.getBlobClient(blobPath).getBlockBlobClient();

      await blockBlobClient.uploadBrowserData(file, { blockSize: 4 * 1024 * 1024, concurrency: 20 });
      await runReport(currentRow.esgMetric, currentRow.siteLocationId, "PDF", blobPath);
    } catch (error) {
      setSloading(false);
      Swal.fire({ icon: "error", title: "Error", text: error.message || "Failed to process PDF" }).then(() => handleCloseDefaultModal());
    }
  };

  // Handle PDF Upload - allows uploading new PDF during each run
  const handlePdfUpload = (row) => {
    if (pdfFileRef.current) {
      pdfFileRef.current.value = "";
      pdfFileRef.current.click();
    }
  };

  const showEditModal = (module, esg, site, file) => {
    const type = localStorage.setItem("type", file);
    setActiveStep(0);
    setModule(esg);
    setMyModule(esg);
    setESG(esg);
    setMatrics(esg);
    setSite(site);
    setSiteLocation1(site);
    setFile(file);
    setPattern(file);
    setSelectedExcel(file);
    console.log(file);
    setEditIsOpen(true);
  };

  const hideEditModal = () => {
    setEditIsOpen(false);
  };

  async function fetchSiteLocation() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-sitelocation`, requestOptions);
      const data = await response.json();
      setSiteLocation(data.data);
    } catch (error) {
      console.error(error);
    }
  }

  async function fetchESGMatrics(value) {
    try {
      var myHeaderss = new Headers();
      myHeaderss.append("username", username);
      myHeaderss.append("param", value);
      var requestOptionss = {
        method: "GET",
        headers: myHeaderss,
        redirect: "follow",
      };
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}ESG`, requestOptionss);
      const data = await response.json();
      setMyMatrics(data);
    } catch (error) {
      console.error(error);
    }
  }

  const showDeleteModal = (site, file, esg) => {
    setSite(site);
    setFile(file);
    setESG(esg);
    setDeleteName(site);
    setDeleteMessage("Are you sure you want to deactivate this connection for " + esg + " - " + site + "?");
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  // Handle the search of the item
  const searchData = async () => {
    console.log(searchsite);
    var site = searchsite;
    var esg = searchesg;
    const data = localStorage.getItem("allconfig");
    console.log(data);
    if (searchsite === "" && searchesg === "") {
      if (data) {
        const parsedData = JSON.parse(data);
        setActiveConfig(parsedData);
      }
    }
    if (searchsite !== "" && searchesg !== "") {
      if (data) {
        const parsedData = JSON.parse(data);
        const filteredData = parsedData.filter((item) => {
          return item.siteLocationId === searchsite && item.esgMetric === searchesg;
        });
        console.log(filteredData);
        setActiveConfig(filteredData);
      }
    }
    if (searchsite === "" && searchesg !== "") {
      if (data) {
        const parsedData = JSON.parse(data);
        const filteredData = parsedData.filter((item) => {
          return item.esgMetric === searchesg;
        });
        setActiveConfig(filteredData);
        console.log(filteredData);
      }
    }
    if (searchsite !== "" && searchesg === "") {
      if (data) {
        const parsedData = JSON.parse(data);
        const filteredData = parsedData.filter((item) => {
          return item.siteLocationId === searchsite;
        });
        console.log(filteredData);
        setActiveConfig(filteredData);
      }
    }
  };

  const reactive = async (name, esg, file) => {
    setLoading(true);
    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}reactive-configuration`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          username: username,
          file: file,
          esg: esg,
          name: name,
        },
        body: JSON.stringify({}),
      });
      //let resJson = await res.json();
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.data,
          });
        } else if (responseJson.status == 400) {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.title,
          });
        } else {
          setLoading(false);
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Configuration reactivated successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
        }
        fetchConnectorConfig();
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error in reactivate configuration",
        });
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  // Handle the actual deletion of the item
  const submitDelete = async () => {
    console.log(deletename);
    try {
      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}delete-connector-cofig`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          site: site,
          file: file,
          esg: esg,
          username: username,
        },
        body: JSON.stringify({}),
      });
      //let resJson = await res.json();
      if (res.status === 200) {
        fetchConnectorConfig();
        const responseJson = await res.json();
        if (responseJson.success == false) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.data,
          });
        } else if (responseJson.status == 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.title,
          });
        } else {
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Connector Config Deactivated successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          });
        }
        setDisplayConfirmationModal(false);
      } else {
        toast.error("Error In Deactivate Connector Config");
        setDisplayConfirmationModal(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Process configurations to handle connectorNames array from backend
  const processConfigsWithConnectors = (configs) => {
    return configs.map((config) => {
      // Check if backend already provides connectorNames as an array
      if (Array.isArray(config.connectorNames) && config.connectorNames.length > 0) {
        // Backend already grouped data with connectorNames array
        const connectorNameMap = {};

        // If we have connector names, map them
        config.connectorNames.forEach((connectorName, index) => {
          // Try to extract connector type from name or use a pattern
          // Assuming the backend might send connector types in the array
          connectorNameMap[connectorName] = connectorName;
        });

        return {
          ...config,
          connectors: config.connectorNames, // Use the array from backend
          connectorNamesMap: connectorNameMap,
        };
      }

      // If backend sends separate rows, group them
      return {
        ...config,
        connectors: config.fileFormat ? [config.fileFormat] : [],
        connectorNamesMap: { [config.fileFormat]: config.connectorName || "" },
      };
    });
  };

  async function fetchConnectorConfig() {
    setSloading(true);
    try {
      setIsLoading(true);
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-new-connector-config`, requestOptions);
      if (response.status === 200) {
        const responseJson = await response.json();
        if (responseJson.success == false) {
          console.log("buraya bak: ");
          console.log(responseJson);
          setSloading(false);
          setConfig("");
        } else if (responseJson.status == 400) {
          setSloading(false);
          setConfig("");
        } else {
          setSloading(false);
          localStorage.setItem("allconfig", JSON.stringify(responseJson.data));
          setConfig(responseJson.data);

          // Process active and inactive configs to handle connectorNames array
          const activeData = responseJson.data.filter((item) => item.isActive === true);
          const inactiveData = responseJson.data.filter((item) => item.isActive === false);

          console.log("Active Data Sample:", activeData[0]); // Debug log
          console.log("Connector Names from Backend:", activeData[0]?.connectorNames); // Debug log

          setActiveConfig(processConfigsWithConnectors(activeData));
          setDeactiveConfig(processConfigsWithConnectors(inactiveData));
          setActiveCounter(activeData.length);
          setInActiveCounter(inactiveData.length);
        }
      } else {
        setSloading(false);
        setConfig("");
      }
      setIsLoading(false);
    } catch (error) {
      setSloading(false);
      setIsLoading(false);
      console.error(error);
    }
  }

  async function fetchModules() {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}list-modules`);
      const data = await response.json();
      setModules(data.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchConnectorConfig();
    fetchModules();
    fetchSiteLocation();
  }, []);

  const onDrop = useCallback((acceptedFiles, site, type, esgmetric) => {
    setSloading(true);
    console.log("Run reoprt started");
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (evt) => {
        // evt = on_file_select event
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: true });
        const columnsArray = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames], { header: 1 })[0];
        setHeaderFields(columnsArray);
        const rowData = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames], { raw: true });
        const newdatas = [];
        const convertedData = rowData.map((row) => {
          const convertedRow = {};
          for (let key in row) {
            if (typeof row[key] === "number") {
              const regex = /[dD][aA][tT][eE]/i;
              const match = regex.exec(key);
              const unit = /^[Uu][Nn][Ii][Tt]$/i;
              const unitMatch = regex.exec(key);
              if (match) {
                console.log(key + " Date");
                const excelToDate = (excelDate) => {
                  const MS_PER_DAY = 86400000;
                  const EPOCH_DATE = 25569; // January 1, 1970 is the 25569th day in the Excel date system
                  const epoch = (excelDate - EPOCH_DATE) * MS_PER_DAY;
                  return new Date(epoch);
                };
                // Use ISO yyyy-MM-dd to avoid DD/MM vs MM/DD ambiguity on the backend
                const d2 = excelToDate(row[key]);
                convertedRow[key] = d2.getUTCFullYear() + "-" + String(d2.getUTCMonth() + 1).padStart(2, "0") + "-" + String(d2.getUTCDate()).padStart(2, "0");
              } else if (unitMatch) {
                convertedRow[key] = "";
              } else {
                convertedRow[key] = row[key].toString();
              }
            } else if (row[key] instanceof Date) {
              const regex = /[dD][aA][tT][eE]/i;
              if (regex.test(key)) {
                const d = row[key];
                convertedRow[key] = d.getUTCFullYear() + "-" + String(d.getUTCMonth() + 1).padStart(2, "0") + "-" + String(d.getUTCDate()).padStart(2, "0");
              } else {
                convertedRow[key] = row[key];
              }
            } else {
              convertedRow[key] = row[key];
            }
          }
          newdatas.push(convertedRow);
          return convertedRow;
        });

        console.log(newdatas);
        // Api for run report

        let res = fetch(`${process.env.REACT_APP_BASE_API_URL}RunReportNewConfig`, {
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            username: username,
            site: site,
            type: type,
            esgmetric: esgmetric,
          },
          body: JSON.stringify(newdatas),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success == false) {
              setSloading(false);
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: data.data,
              });
            } else {
              setSloading(false);
              if (data.data.totalRecords === data.data.successfulRecords) {
                Swal.fire({
                  icon: "success",
                  title: "Report Run Successfully",
                  text: "Successfully rows added is " + data.data.successfulRecords,
                  html: '<div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' + data.data.totalRecords + '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left45">Success Records: </div><div class="col-md-3 wd-20">' + data.data.successfulRecords + "</div></div>",
                });
              }
              if (data.data.totalRecords == data.data.failedRecords) {
                const errMap2 = {};
                if (data.data.failedResults && Array.isArray(data.data.failedResults)) {
                  data.data.failedResults.forEach((failedRecord, index) => {
                    if (failedRecord.errors && Array.isArray(failedRecord.errors)) {
                      const rowNum = failedRecord.rowNumber ?? index + 1;
                      failedRecord.errors.forEach((error) => {
                        if (!errMap2[error]) errMap2[error] = [];
                        errMap2[error].push(rowNum);
                      });
                    }
                  });
                }
                const uniqErrs2 = Object.keys(errMap2);
                const allSame2 = uniqErrs2.length === 1 && errMap2[uniqErrs2[0]].length === data.data.failedRecords;
                let allErrHtml2 = "";
                if (uniqErrs2.length > 0) {
                  allErrHtml2 = allSame2
                    ? `<div style="max-height:200px;overflow-y:auto;text-align:left;margin-top:12px;border-top:1px solid #e0e0e0;padding-top:10px;"><p style="font-size:13px;color:#CC2229;margin:4px 0;">• ${uniqErrs2[0]} (all ${data.data.failedRecords} rows)</p><p style="font-size:13px;color:#888;margin-top:8px;font-style:italic;">Tip: The same error on every row usually means the uploaded file uses the wrong template or has incorrect column names.</p></div>`
                    : `<div style="max-height:200px;overflow-y:auto;text-align:left;margin-top:12px;border-top:1px solid #e0e0e0;padding-top:10px;"><p style="font-size:14px;font-weight:bold;margin-bottom:6px;">Error details:</p>${uniqErrs2
                        .map((e) => {
                          const r = errMap2[e];
                          const lbl = r.length > 3 ? `rows ${r.slice(0, 3).join(", ")} and ${r.length - 3} more` : `row${r.length > 1 ? "s" : ""} ${r.join(", ")}`;
                          return `<p style="font-size:13px;margin:3px 0;color:#CC2229;">• ${e} (${lbl})</p>`;
                        })
                        .join("")}</div>`;
                }
                Swal.fire({
                  icon: "error",
                  title: "Report Import Failed",
                  html: '<div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' + data.data.totalRecords + '</div></div><div class="col-md-12 flex1"> <div class="col-md-9 wd-70 pd-left35">Invalid Records: </div><div class="col-md-3 wd-20">' + data.data.failedRecords + "</div></div>" + allErrHtml2,
                  width: "600px",
                });
              }
              if (data.data.failedRecords >= 1 && data.data.totalRecords !== data.data.failedRecords) {
                const partErrMap2 = {};
                if (data.data.failedResults && Array.isArray(data.data.failedResults)) {
                  data.data.failedResults.forEach((failedRecord, index) => {
                    if (failedRecord.errors && Array.isArray(failedRecord.errors)) {
                      const rowNum = failedRecord.rowNumber ?? index + 1;
                      failedRecord.errors.forEach((error) => {
                        if (!partErrMap2[error]) partErrMap2[error] = [];
                        partErrMap2[error].push(rowNum);
                      });
                    }
                  });
                }
                const partUniq2 = Object.keys(partErrMap2);
                let partErrHtml2 = "";
                if (partUniq2.length > 0) {
                  partErrHtml2 = `<div style="max-height:200px;overflow-y:auto;text-align:left;margin-top:12px;border-top:1px solid #e0e0e0;padding-top:10px;"><p style="font-size:14px;font-weight:bold;margin-bottom:6px;">Error details for failed rows:</p>${partUniq2
                    .map((e) => {
                      const r = partErrMap2[e];
                      const lbl = r.length > 3 ? `rows ${r.slice(0, 3).join(", ")} and ${r.length - 3} more` : `row${r.length > 1 ? "s" : ""} ${r.join(", ")}`;
                      return `<p style="font-size:13px;margin:3px 0;color:#CC2229;">• ${e} (${lbl})</p>`;
                    })
                    .join("")}</div>`;
                }
                Swal.fire({
                  icon: "warning",
                  title: "Report Run Successfully",
                  html:
                    '<div class="col-md-12 flex1"><div class="col-md-9 wd-70">Total Records: </div><div class="col-md-3 wd-20">' +
                    data.data.totalRecords +
                    '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left45">Success Records: </div><div class="col-md-3 wd-20">' +
                    data.data.successfulRecords +
                    '</div></div><div class="col-md-12 flex1"><div class="col-md-9 wd-70 pd-left35">Invalid Records: </div><div class="col-md-3 wd-20">' +
                    data.data.failedRecords +
                    "</div></div>" +
                    partErrHtml2,
                  width: "600px",
                });
              }
            }
          })
          .catch((error) => {
            setSloading(false);
            console.log(error);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Error In Run Report",
            });
          });

        var result = columnsArray
          .map(function (val) {
            return val;
          })
          .join(",");
        var item = "";
        var results = {};

        if (result !== null) {
          result = result.split(",");

          for (var i = 0; i < result.length; i++) {
            item = result[i].trim();

            results[item] = item;
          }
        }
        /* Update state */
        const jsonData = JSON.parse(JSON.stringify(data));
        setLoading(false);
      };
      reader.readAsBinaryString(file);
    });
  }, []);

  const excel = {
    width: "50px",
  };

  async function uploadFileName(filename, esgMetric) {
    const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetPdfParameterAsync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        fileName: filename,
        esgMetric: esgMetric,
        userEmail: username,
      }),
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      if (responseJson.success == false) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: responseJson.data,
        });
      } else {
        console.log(responseJson.data);
        function combine(collections) {
          const entries = [...Object.entries(collections)];
          const length = entries[0]?.[1]?.length ?? 0;
          const result = [];
          for (const [name, array] of entries) {
            if (array.length !== length) throw new Error("Non-uniform array lengths");
            for (let i = 0; i < length; i += 1) {
              const item = (result[i] ??= {});
              item[name] = array[i];
            }
          }
          return result;
        }
        const businessUnitValues = Object.values(responseJson.data);
        const businessUnitKeys = Object.keys(responseJson.data);
        const merge = () => {
          const merged = combine({
            businessunitvalue: businessUnitValues,
            businessunit: businessUnitKeys,
          });
          console.log(merged);
          const businessunitvalues = merged.map((item) => item.businessunit);
          const commaSeparatedArray = businessunitvalues.join(",");
          const dataArray = commaSeparatedArray.split(",");
          setHeaderFields(dataArray);
          Swal.fire({
            icon: "success",
            title: filename + " uploaded successfully",
          });
          console.log(dataArray);
        };

        merge();
        setImportFile(filename);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pdf not uploaded",
      });
    }
  }

  //Run Report for other app names
  async function runReport(esgM, siteL, connector, fileName = null) {
    setSloading(true);
    try {
      const requestBody = {
        userEmail: username,
        esgMetric: esgM,
        siteLocation: siteL,
        ConnectorName: connector,
        forceRunReport: true,
      };

      // Include fileName for PDF connector (full blob path)
      if (fileName) {
        requestBody.fileName = fileName;
      }

      let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}run-report-other`, {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(requestBody),
      });
      //let resJson = await res.json();
      if (res.status === 200) {
        const responseJson = await res.json();
        if (responseJson.success == false) {
          setSloading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.data,
          }).then(() => {
            handleCloseDefaultModal();
          });
        } else if (responseJson.status == 400) {
          setSloading(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: responseJson.title,
          }).then(() => {
            handleCloseDefaultModal();
          });
        } else {
          setSloading(false);
          Swal.fire({
            icon: "success",
            html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Report run successfully</p>',
            iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
          }).then(() => {
            handleCloseDefaultModal();
          });
        }
        setDisplayConfirmationModal(false);
      } else {
        setSloading(false);
        toast.error("Error In report run");
        setDisplayConfirmationModal(false);
        handleCloseDefaultModal();
      }
    } catch (err) {
      setSloading(false);
      console.log(err);
      handleCloseDefaultModal();
    }
  }
  //Run Report for other app names
  // async function runReport (esgM,siteL,connector) {
  //   setLoading(true);
  //   try {
  //     let res = await fetch("https://ecoprismapi.azurewebsites.net/run-report-other", {
  //       method: "POST",
  //       headers: {
  //         'Content-type': 'application/json; charset=UTF-8',
  //       },
  //       body: JSON.stringify({
  //         userEmail:username,
  //         esgMetric:esgM,
  //         siteLocation:siteL,
  //         ConnectorName:connector,
  //         forceRunReport:true
  //       })
  //     });
  //     //let resJson = await res.json();
  //     if (res.status === 200) {
  //       const responseJson = await res.json();
  //       if(responseJson.success == false){
  //         setLoading(false);
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Oops...',
  //           text: responseJson.data
  //         });
  //       }
  //       else if(responseJson.status == 400){
  //         setLoading(false);
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Oops...',
  //           text: responseJson.title
  //         });
  //       }
  //       else{
  //         setLoading(false);
  //         Swal.fire({
  //           icon: 'success',
  //           html: '<h4 style="color:#407775;font-size: 20px;">Success!</h4><p style="font-size:16px;">Report run successfully</p>',
  //             iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',

  //         });
  //       }
  //       setDisplayConfirmationModal(false);
  //     } else {
  //       setLoading(false);
  //       toast.error('Error In report run');
  //       setDisplayConfirmationModal(false);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  //PDF Code
  async function uploadImage(containerName, file) {
    console.log(file);
    let res = await fetch(`${process.env.REACT_APP_BASE_API_URL}GetSASToken`, {
      method: "GET",
    });
    if (res.status === 200) {
      const responseJson = await res.json();
      const connectionString = responseJson.data;
      const blobServiceClient = new BlobServiceClient(connectionString);
      console.log(connectionString);
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlobClient(file.name);
      console.log(blobClient);
      const blockBlobClient = blobClient.getBlockBlobClient();
      console.log(blockBlobClient);
      const result = await blockBlobClient.uploadBrowserData(file, {
        blockSize: 4 * 1024 * 1024,
        concurrency: 20,
        onProgress: (ev) => console.log(ev),
      });
      console.log(result);
      if (result) {
        console.log(file.name);
        uploadFileName(file.name, esg);
      }

      //console.log(`Upload of file '${file.name}' completed`);
    } else {
    }
  }

  const onDrops = useCallback((acceptedFiles) => {
    console.log(acceptedFiles);
    const type = localStorage.getItem("type");
    setImportFile(acceptedFiles[0].name);
    const name = acceptedFiles[0].name;
    const extension = name.split(".").pop();
    let sendObj = {
      startDate: "",
      endDate: "",
      energyCons: 0,
    };
    if (type === "Excel") {
      if (extension === "xls" || extension === "xlsx") {
        acceptedFiles.forEach((file) => {
          const reader = new FileReader();
          reader.onload = (evt) => {
            // evt = on_file_select event
            /* Parse data */
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: true });
            //const workbookHeaders = XLSX.readFile(bstr, { sheetRows: 1 });
            console.log(data);
            if (data.length === 0) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Excel File is not proper or header is not present",
              });
              console.log("The array is empty.");
              return false;
              // Perform actions for an empty array
            }
            setImportFile(acceptedFiles[0].name);
            Swal.fire({
              icon: "success",
              html: acceptedFiles[0].name + " uploaded successfully",
              iconHtml: '<img src="assets/img/successicon.png" style="width: 55px; height: 55px;" />',
            });
            const columnsArray = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames], {
              header: 1,
            })[0];
            console.log(columnsArray);
            setHeaderFields(columnsArray);
            var result = columnsArray
              .map(function (val) {
                return val;
              })
              .join(",");
            var item = "";
            var results = {};

            if (result !== null) {
              result = result.split(",");

              for (var i = 0; i < result.length; i++) {
                item = result[i].trim();

                results[item] = item;
              }
            }
            /* Update state */
            const jsonData = JSON.parse(JSON.stringify(data));
            const newdata = [];
            _.forEach(jsonData, (jd) => {
              sendObj.energyCons = jd.EnergyConsumption;
              sendObj.startDate = jd.StartDate;
              sendObj.endDate = jd.EndDate;
              newdata.push({
                email: "sudies@ecoprism.com",
                energy: sendObj.energyCons,
                region: "DK",
                reportPeriod: 2,
                endTimeEpoch: sendObj.endDate,
                unit: "kWh",
              });
              //console.log(jd, 'hsdajshd')
            });
            setLoading(false);
          };
          reader.readAsBinaryString(file);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "File format is not valid",
        });
        setImportFile();
        return false;
      }
    }
    if (type === "PDF") {
      if (extension === "pdf") {
        uploadImage("ecoprismfilecontainer", acceptedFiles[0]);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "File format is not valid",
        });
        setImportFile();
        return false;
      }
    }
  }, []);

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [activeTable, setActiveTable] = useState(true);
  const [inactiveTable, setInActiveTable] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [activePage, setActivePage] = useState(0);
  const [inactivePage, setInactivePage] = useState(0);
  const [activeRowsPerPage, setActiveRowsPerPage] = useState(10);
  const [inactiveRowsPerPage, setInactiveRowsPerPage] = useState(10);
  // Active Table Page Change Handler
  const handleActivePageChange = (event, newPage) => {
    setActivePage(newPage);
  };

  // Inactive Table Page Change Handler
  const handleInactivePageChange = (event, newPage) => {
    setInactivePage(newPage);
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page

  const toggleTable = (isActiveTable) => {
    if (isActiveTable === true) {
      setActivePage(0);
      setActiveTable(true);
      setInActiveTable(false);
    } else {
      setActivePage(0);
      setActiveTable(false);
      setInActiveTable(true);
    }
  };

  const [filters, setFilters] = useState({
    siteLocationId: "",
    esgMetric: "",
    reportFrequency: "",
    fileFormat: "",
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setPage(0);
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };
  return (
    <div id="wrapper">
      <div>
        {sloading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      <div>
        <Toaster position="top-right" reverseOrder={false} />
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div class="container formpd">
          <div class="flex">
            <div class="col-md-9 pd-0">
              <div Class="steps__containt-hader">
                <h3 class="title">All Configurations</h3>
                <div role="presentation">
                  <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="">
                      Configuration
                    </Link>
                    <Typography color="text.primary">All Configurations</Typography>
                  </Breadcrumbs>
                </div>
              </div>
            </div>
            <div class="col-md-3 pd-0">
              <div Class="steps__containt-hader btalignleft">
                <a href="/newconfig" className="add-cta">
                  + Setup New Configuration
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-12 flex justify-content-between align-items-center pd-0 mb-2">
            {/* Left: Active/Inactive Buttons */}
            <div className="flex gap-3">
              <button className={activeTable ? "active-buttongreen" : "inactive-buttongreen"} onClick={() => toggleTable(true)}>
                <span className="record-count">{activeCounter}</span>
                Active
              </button>
              <button className={!activeTable ? "active-buttonred" : "inactive-buttonred"} onClick={() => toggleTable(false)}>
                <span className="record-count">{inactiveCounter}</span>
                Inactive
              </button>
            </div>

            {/* Right: Filter Dropdown with Label on the same line */}
            <div className="flex align-items-center gap-2">
              <label className="formlable whitespace-nowrap mb-0 me-3" htmlFor="filterBy">
                Filter By
              </label>
              <Dropdown
                id="filterBy"
                value={filterValue}
                options={[
                  { label: "Site Location", value: "siteLocationId" },
                  { label: "Legal Entity", value: "legalEntity" },
                ]}
                onChange={(e) => setFilterValue(e.value)}
                placeholder="Select filter type"
                className="p-inputtext-sm"
                required
                style={{ fontSize: "13px", width: "200px" }}
              />
            </div>
          </div>

          <div class="col-md-12 pd-0 survey-form">
            {activeTable ? (
              <div className="data-responsive">
                <DataTable
                  value={activeconfig}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 25, 50]}
                  tableStyle={{ minWidth: "50rem" }}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  filterDisplay="row"
                  dataKey="siteLocationId"
                  globalFilterFields={["siteLocationId", "esgMetric", "reportFrequency", "fileFormat"]}
                  emptyMessage="No active configurations found."
                  className="p-datatable-gridlines"
                >
                  <Column
                    body={(rowData) => (
                      <div className="actions">
                        <Tooltip title="Edit Configuration" arrow>
                          <EditIcon style={{ cursor: "pointer", color: "#407775", width: "20px", height: "20px" }} onClick={() => RedirectToEditConfiguration(rowData.esgMetric, rowData.siteLocationId)} />
                        </Tooltip>
                        <Tooltip title="Deactivate Configuration" arrow>
                          <img className="action-icon" src="assets/img/deactivate.png" alt="Deactivate" onClick={() => showDeleteModal(rowData.siteLocationId, rowData.fileFormat || rowData.connectors?.[0], rowData.esgMetric)} style={{ cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    )}
                    style={{ width: "3rem", textAlign: "center", paddingLeft: "30px" }}
                  />
                  {filterValue === "siteLocationId" ? <Column field="siteLocationId" header="Site Location" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} /> : <Column field="legalEntity" header="Legal Entity" sortable filter filterPlaceholder="Filter" style={{ minWidth: "180px", padding: "0 10px" }} body={(row) => row.legalEntity || "—"} />}
                  <Column field="esgMetric" header="ESG Parameter" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column field="topic" header="Topic" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column field="subtopic" header="Subtopic" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column field="reportFrequency" header="Data Frequency" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column
                    header="Data Connector"
                    body={(rowData) => {
                      const getConnectorImage = (fileFormat) => {
                        switch (fileFormat) {
                          case "Excel":
                            return "assets/img/2.png";
                          case "API":
                            return "assets/img/api2.png";
                          case "Azure Table Storage":
                            return "assets/img/azuretablestorage.png";
                          case "PDF":
                            return "assets/img/pdf.png";
                          default:
                            return "";
                        }
                      };

                      // Display all connectors for this grouped row
                      const connectors = rowData.connectors || [rowData.fileFormat];

                      // Debug log for test18ray
                      if (rowData.siteLocationId === "test18ray") {
                        console.log("=== test18ray Debug ===");
                        console.log("Connectors Array:", connectors);
                        console.log("Full Row Data:", rowData);
                        connectors.forEach((conn, idx) => {
                          console.log(`Connector ${idx}: "${conn}" -> Image: ${getConnectorImage(conn)}`);
                        });
                      }

                      return (
                        <div style={{ flexDirection: "column", gap: "5px", alignItems: "flex-start" }}>
                          {connectors.map((connector, index) => {
                            const imgSrc = getConnectorImage(connector);
                            if (!imgSrc) {
                              console.warn(`No image for: "${connector}"`);
                              return null;
                            }
                            return <img key={index} src={imgSrc} alt={connector} title={connector} style={{ width: "40px", height: "30px" }} />;
                          })}
                        </div>
                      );
                    }}
                    style={{ minWidth: "150px", paddingLeft: "10px", paddingRight: "10px" }}
                  />
                  <Column header="Last Refresh" body={(rowData) => new Date(rowData.updatedAt).toLocaleString("en-GB")} style={{ minWidth: "200px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column
                    header="Run"
                    body={(rowData) => {
                      // Use the pre-grouped connectors data
                      const connectorList = rowData.connectors || [rowData.fileFormat];
                      const connectorNameMap = rowData.connectorNamesMap || rowData.connectorNames || { [rowData.fileFormat]: rowData.connectorName };

                      return (
                        <Tooltip title="Run Report" arrow>
                          <Link2 className="cursor-pointer" style={{ color: "#407775", width: "20px", height: "20px", cursor: "pointer" }} onClick={() => handleConnectorModal(connectorList, connectorNameMap, rowData)} />
                        </Tooltip>
                      );
                    }}
                    style={{ minWidth: "80px", textAlign: "center", paddingLeft: "10px", paddingRight: "10px" }}
                  />

                  <Column
                    header="Report History"
                    body={(rowData) => (
                      <Tooltip title="View Report History" arrow>
                        <a href={`/reporthistory?sl=${rowData.siteLocationId}&esg=${rowData.esgMetric}&topic=${encodeURIComponent(rowData.topic || "")}&subtopic=${encodeURIComponent(rowData.subtopic || "")}`}>
                          <IoEye className="cursor-pointer" style={{ color: "407775", width: "20px", height: "20px" }} />
                        </a>
                      </Tooltip>
                    )}
                    style={{ minWidth: "120px", textAlign: "center", paddingLeft: "10px", paddingRight: "10px" }}
                  />
                </DataTable>
              </div>
            ) : (
              <div></div>
            )}
            {inactiveTable ? (
              <div className="data-responsive">
                <DataTable
                  value={deactiveconfig}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 25, 50]}
                  tableStyle={{ minWidth: "50rem" }}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  filterDisplay="row"
                  dataKey="siteLocationId"
                  globalFilterFields={["siteLocationId", "esgMetric", "reportFrequency", "fileFormat"]}
                  emptyMessage="No inactive configurations found."
                  className="p-datatable-gridlines"
                >
                  <Column
                    body={(rowData) => (
                      <div className="actions">
                        <Tooltip title="Reactivate Configuration" arrow>
                          <img className="action-icon" src="assets/img/reactivate.png" alt="Reactivate" onClick={() => reactive(rowData.siteLocationId, rowData.esgMetric, rowData.fileFormat || rowData.connectors?.[0])} style={{ cursor: "pointer" }} />
                        </Tooltip>
                      </div>
                    )}
                    style={{ textAlign: "center", paddingLeft: "30px" }}
                  />
                  {filterValue === "siteLocationId" ? <Column field="siteLocationId" header="Site Location" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} /> : <Column field="legalEntity" header="Legal Entity" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} body={(row) => row.legalEntity || "—"} />}{" "}
                  <Column field="esgMetric" header="ESG Parameter" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column field="topic" header="Topic" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column field="subtopic" header="Subtopic" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column field="reportFrequency" header="Data Frequency" filter sortable filterPlaceholder="Filter" style={{ minWidth: "180px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column
                    header="Data Connector"
                    body={(rowData) => {
                      const getConnectorImage = (fileFormat) => {
                        switch (fileFormat) {
                          case "Excel":
                            return "assets/img/2.png";
                          case "API":
                            return "assets/img/api2.png";
                          case "Azure Table Storage":
                            return "assets/img/azuretablestorage.png";
                          case "PDF":
                            return "assets/img/pdf.png";
                          default:
                            return "";
                        }
                      };

                      // Display all connectors for this grouped row
                      const connectors = rowData.connectors || [rowData.fileFormat];

                      // Debug log for test18ray
                      if (rowData.siteLocationId === "test18ray") {
                        console.log("=== test18ray Debug ===");
                        console.log("Connectors Array:", connectors);
                        console.log("Full Row Data:", rowData);
                        connectors.forEach((conn, idx) => {
                          console.log(`Connector ${idx}: "${conn}" -> Image: ${getConnectorImage(conn)}`);
                        });
                      }

                      return (
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px", alignItems: "flex-start" }}>
                          {connectors.map((connector, index) => {
                            const imgSrc = getConnectorImage(connector);
                            if (!imgSrc) {
                              console.warn(`No image for: "${connector}"`);
                              return null;
                            }
                            return <img key={index} src={imgSrc} alt={connector} title={connector} style={{ width: "40px", height: "30px" }} />;
                          })}
                        </div>
                      );
                    }}
                    style={{ minWidth: "150px", paddingLeft: "10px", paddingRight: "10px" }}
                  />
                  <Column header="Last Refresh" body={(rowData) => new Date(rowData.updatedAt).toLocaleString("en-GB")} style={{ minWidth: "200px", paddingLeft: "10px", paddingRight: "10px" }} />
                  <Column
                    header="Run"
                    body={(rowData) => {
                      // Use the pre-grouped connectors data
                      const connectorList = rowData.connectors || [rowData.fileFormat];
                      const connectorNameMap = rowData.connectorNamesMap || rowData.connectorNames || { [rowData.fileFormat]: rowData.connectorName };

                      return (
                        <Tooltip title="Run Report" arrow>
                          <Link2 className="cursor-pointer" style={{ color: "#407775", width: "20px", height: "20px", cursor: "pointer" }} onClick={() => handleConnectorModal(connectorList, connectorNameMap, rowData)} />
                        </Tooltip>
                      );
                    }}
                    style={{ minWidth: "80px", textAlign: "center", paddingLeft: "10px", paddingRight: "10px" }}
                  />
                  <Column
                    header="Report History"
                    body={(rowData) => (
                      <div>
                        <a href={`/reporthistory?sl=${rowData.siteLocationId}&esg=${rowData.esgMetric}&topic=${encodeURIComponent(rowData.topic || "")}&subtopic=${encodeURIComponent(rowData.subtopic || "")}`}>
                          <RemoveRedEyeIcon className="run-icon" style={{ cursor: "pointer", color: "#407775" }} />
                        </a>
                      </div>
                    )}
                    style={{ minWidth: "120px", textAlign: "center", paddingLeft: "10px", paddingRight: "10px" }}
                  />
                </DataTable>
              </div>
            ) : (
              <div></div>
            )}
          </div>

          <DeleteConfirmation confirmModal={submitDelete} showModal={displayConfirmationModal} hideModal={hideConfirmationModal} message={deleteMessage} deletename={deletename} />
          {/* Hidden file inputs — must be in DOM (not body) so file picker works inside modal context */}
          <input type="file" ref={excelFileRef} accept=".xlsx,.xls" style={{ display: "none" }} onChange={handleExcelFileChange} />
          <input type="file" ref={pdfFileRef} accept=".pdf" style={{ display: "none" }} onChange={handlePdfFileChange} />

          <Modal show={showDefaultModal} onHide={handleCloseDefaultModal} centered className="custom-modal-width reports-modal add-default-value-modal">
            <Modal.Header className="justify-content-between">
              <Modal.Title>Connectors List</Modal.Title>
              <Button variant="link" className="close-modal-button" onClick={handleCloseDefaultModal} style={{ padding: "0", minWidth: "0" }}>
                <IoIosCloseCircleOutline style={{ color: "white", fontSize: "24px" }} />
              </Button>
            </Modal.Header>
            <Modal.Body>
              <div className="data-responsive survey-form">
                <DataTable
                  value={selectedExcel.map((connector, index) => {
                    console.log(`Rendering row ${index}:`, connector, "->", connectorNames[connector]);
                    const connectorUpper = (connector || "").toUpperCase();
                    return {
                      id: index,
                      type: connector, // e.g., "Excel" or "API"
                      name: connectorNames[connector] || "", // e.g., "Abc.xls"
                      isExcel: connectorUpper === "EXCEL",
                      isPdf: connectorUpper === "PDF",
                    };
                  })}
                  className="p-datatable-sm"
                  responsiveLayout="scroll"
                  rowClassName={() => "bg-gray-50 even:bg-white"} // Light alternating rows
                >
                  <Column
                    field="type"
                    header="Connector Type"
                    headerStyle={{ paddingLeft: "20px" }}
                    body={(rowData) => {
                      // Get the connector image based on type
                      const getConnectorImage = (type) => {
                        switch (type) {
                          case "Excel":
                            return "assets/img/2.png";
                          case "API":
                            return "assets/img/api2.png";
                          case "Azure Table Storage":
                            return "assets/img/azuretablestorage.png";
                          case "PDF":
                            return "assets/img/pdf.png";
                          default:
                            return "";
                        }
                      };

                      return (
                        <div style={{ paddingLeft: "5px", gap: "5px" }}>
                          {getConnectorImage(rowData.type) && <img src={getConnectorImage(rowData.type)} alt={rowData.type} style={{ width: "40px", height: "30px" }} />}
                          <span>{rowData.type}</span>
                        </div>
                      );
                    }}
                  />
                  <Column field="name" header="Connector Name" body={(rowData) => <span>{rowData.name}</span>} />
                  <Column
                    header="Action"
                    body={(rowData) => {
                      // Excel and PDF both get Upload button, others get Run
                      if (rowData.isExcel) {
                        return (
                          <button type="button" onClick={() => handleUpload(rowData)} className="font-semibold underline text-[#FAB430] cursor-pointer bg-transparent border-0 p-0 m-0" style={{ appearance: "none", WebkitAppearance: "none", color: "#fab430", textDecoration: "underline" }}>
                            Upload
                          </button>
                        );
                      } else if (rowData.isPdf) {
                        return (
                          <button type="button" onClick={() => handlePdfUpload(rowData)} className="font-semibold underline text-[#FAB430] cursor-pointer bg-transparent border-0 p-0 m-0" style={{ appearance: "none", WebkitAppearance: "none", color: "#fab430", textDecoration: "underline" }}>
                            Upload
                          </button>
                        );
                      } else {
                        return (
                          <button type="button" onClick={() => handleRun(rowData)} className="font-semibold underline text-[#FAB430] cursor-pointer bg-transparent border-0 p-0 m-0" style={{ appearance: "none", WebkitAppearance: "none", color: "#fab430", textDecoration: "underline" }}>
                            Run
                          </button>
                        );
                      }
                    }}
                  />
                </DataTable>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "start", padding: "20px 40px" }}>
              <Button className="outline-btn" variant="outlined" onClick={handleCloseDefaultModal}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <div class="container">{message}</div>
        </div>
      </div>
    </div>
  );
}
